var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDragonhubLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 102.248 100.184",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2.837641, 2.409932)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95.481 95.481",
    height: 95.481,
    width: 95.481,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95.481 95.481",
    height: 95.481,
    width: 95.481,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95.481 95.481",
    height: 95.481,
    width: 95.481,
    id: "textblock",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95.481 95.481",
    height: 95.481,
    width: 95.481,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95.481 95.481",
    height: 95.481,
    width: 95.481,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    "aria-labelledby": titleId
  }, props))), /*#__PURE__*/React.createElement("g", {
    id: "icon-0"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 95.481 95.481",
    height: 95.481,
    width: 95.481,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M28.644 95.481c-15.82 0-28.644-12.824-28.644-28.644v-38.193c0-15.82 12.824-28.644 28.644-28.644h38.193c15.82 0 28.644 12.824 28.644 28.644v38.193c0 15.82-12.824 28.644-28.644 28.644z",
    fill: "#ff585f",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    },
    "data-fill-palette-color": "accent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,19.096200000000003,24.70282955849227)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57.28859999999999 46.07534088301546",
    height: 46.07534088301546,
    width: 57.28859999999999,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 9.78600025177002 100.0003433227539 80.42699432373047",
    x: 0,
    y: 0,
    height: 46.07534088301546,
    width: 57.28859999999999,
    className: "icon-b-0",
    "data-fill-palette-color": "quaternary",
    id: "b-0",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.942 52.994l40.653-1.465c-2.527-4.177-3.159-7.831-7.989-8.461q-10.843-1.41-21.688-2.826l-42.075-5.48c1.258 2.03 20.881 18.599 31.099 18.232M0 9.786c4.391 7.257 26.615 23.072 32.953 23.886q25.994 3.346 51.986 6.688c-3.393-5.607-4.18-9.35-10.312-10.959L47.91 22.378Q23.955 16.084 0 9.786M63.108 66.207l31.241-6.66c-2.028-3.346-2.034-5.359-5.827-5.189q-9.236 0.411-18.471 0.822-17.015 0.76-34.028 1.518c1.275 1.366 18.917 11.249 27.085 9.509M87.682 90.213c5.725-3.719 7.262-7.721 10.519-13.807 3.651-6.824 1.257-7.844-2.821-14.596-0.417-0.688-5.842 0.232-6.453 0.904-0.745 0.818-0.248 5.455-0.294 6.496zM86.35 63.447c-3.795 0.809-8.604 0.191-9.572 4.229l-4.12 17.211c9.246-2.209 13.37-13.305 13.692-21.44M74.666 66.121c-9.148 1.953-8.956 4.611-12.879 13.18 6.22-0.59 12.024-7.36 12.879-13.18",
    fill: "#ffffff",
    "data-fill-palette-color": "quaternary"
  })))))))))))))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDragonhubLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dragonhub-logo.81e52f005f8acee1f776e0822b489e1e.svg";